import { FC } from 'react';

import IconComponent from './IconComponent';

import { ICONS } from '../utils/enum/Icons';

interface Props {
    text: string;
    style: 'link' | 'link-light' | 'solid' | 'solid-light' | 'outline' | 'circle-icon';
    onClick: () => void;
    icon_left?: ICONS;
    icon_right?: ICONS;
    disabled?: boolean;
    isFile?: boolean;
    customStyle?: React.CSSProperties | undefined;
    customTextStyle?: React.CSSProperties | undefined;
    customIconStyle?: React.CSSProperties | undefined;
    customIconClasses?: string;
    onFileUploaded?: (file: File) => void;
}

const ButtonComponent: FC<Props> = ({
    text,
    style,
    onClick,
    icon_left = '',
    icon_right = '',
    disabled = false,
    isFile = false,
    customStyle = undefined,
    customTextStyle = undefined,
    customIconStyle = undefined,
    customIconClasses = '',
    onFileUploaded = () => {
        return;
    },
}) => {
    const handleClick = () => {
        if (!disabled) {
            onClick();
        }
    };

    const handleChangeUpload = (event: any) => {
        if (event.target.files && event.target.files.length > 0) {
            onFileUploaded(event.target.files[0]);
        }
    };
    return (
        <div style={customStyle} className={`br-button -${style} ${disabled && '-disabled'}`} onClick={handleClick}>
            {isFile ? <input type="file" accept="text/csv" onChange={handleChangeUpload} /> : null}
            {icon_left ? (
                <IconComponent style={customIconStyle} classes={customIconClasses} icon={icon_left as ICONS} />
            ) : null}
            <span style={customTextStyle}>{text}</span>
            {icon_right ? (
                <IconComponent style={customIconStyle} classes={customIconClasses} icon={icon_right as ICONS} />
            ) : null}
        </div>
    );
};

export default ButtonComponent;
